import {
  type GlobalShoppingOfferChoiceDtoBody,
  updateShoppingSessionOfferChoice,
  type UpdateShoppingSessionOfferChoiceHeaders,
} from '@ori/global-api-client-react';

import type { HandlerSettings } from '../types';
import { deleteOfferItem } from './deleteOfferItem';

type UpdateOfferItemHandlerSettings = Pick<HandlerSettings, 'client' | 'sessionId' | 'tenant'>;

export type UpdateOfferItemParams = UpdateOfferItemHandlerSettings & {
  itemCode: string;
  offerId: number;
  quantity: number;
  tenant: string;
};

export async function updateOfferItem(params: UpdateOfferItemParams) {
  const { client, itemCode, offerId, quantity, sessionId, tenant } = params;

  if (quantity === 0) {
    return deleteOfferItem(params);
  }

  const globalShoppingOfferChoiceDtoBody = {
    itemCode,
    quantity,
  } as GlobalShoppingOfferChoiceDtoBody;

  // TODO: Is this needed when there is the tenant prop of ApiProvider applied on some upper level?
  const headers: UpdateShoppingSessionOfferChoiceHeaders = {
    'x-tenant-context': tenant,
  };

  return updateShoppingSessionOfferChoice(
    client,
    sessionId,
    offerId,
    itemCode,
    globalShoppingOfferChoiceDtoBody,
    headers,
  );
}
